import { render } from "./WithNavigation.vue?vue&type=template&id=19037139&scoped=true"
import script from "./WithNavigation.vue?vue&type=script&lang=js"
export * from "./WithNavigation.vue?vue&type=script&lang=js"

import "./WithNavigation.vue?vue&type=style&index=0&id=19037139&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19037139"]])

export default __exports__